import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ErrorBoundary from './ErrorBoundary';
import LoadingSpinner from './LoadingSpinner';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
    const { isInitializing } = useAuth();
    const location = useLocation();

    if (isInitializing) {
        return <LoadingSpinner />;
    }

    const isAdminRoute = location.pathname.startsWith('/dashboard/admin');

    return (
        <ErrorBoundary>
            <div className={isAdminRoute ? "admin-layout" : "app-layout"}>
                {!isAdminRoute && <Header />}
                <main className={isAdminRoute ? "admin-main-container" : "main-content"}>
                    {children}
                </main>
                {!isAdminRoute && <Footer />}
            </div>
        </ErrorBoundary>
    );
};

export default Layout;